(function() {
  'use strict';

  angular
    .module('traineeWebApp.dashboard')
    .controller('RetakeCModuleCtrl', RetakeCModuleCtrl);

  RetakeCModuleCtrl.$inject = ['$scope', 'dashboardResource', '$modalInstance', 'gettext', 'translationService',
    'mtypes', '$rootScope'];

  function RetakeCModuleCtrl($scope, dashboardResource, $modalInstance, gettext, translationService,
                             mtypes, $rootScope) {
    var parentCourse;
    var translate = translationService.sprintf;
    var selectedCModule = $scope.selectedCModule;
    var title = gettext('Confirm retake module?');
    var msg = translate(gettext('All progress in this module will be reset. <br><br> You cannot undo this action.'));

    // TODO: Iverson we should check type but what is it when it is a catalog
    if (selectedCModule.courseId) {
      parentCourse = _.findWhere($scope.traineeCModuleList, { id: selectedCModule.courseId });
      if (parentCourse && parentCourse.newCModulesSinceSnapShot) {
        msg = translate(gettext('This course has changed, retaking this module will require you to take additional modules. <br><br> You cannot undo this action.'));
      }
    }

    if (selectedCModule.type === 'course') {
      title = gettext('Confirm retake course?');
      msg = translate(gettext('All progress in this course will be reset. <br><br> You cannot undo this action.'));
      if (selectedCModule.newCModulesSinceSnapShot) {
        msg = translate(gettext('This course has changed, retaking this course will require you to take additional modules. <br><br> You cannot undo this action.'));
      }
    }

    $scope.setup = {
      title: title,
      message: msg,
      buttons: [
        { label: 'Cancel', cssClass: 'btn-info', result: 'dismiss' },
        { label: 'Retake', cssClass: 'btn-primary', result: 'retake' }
      ]
    };

    $scope.modal = {
      content: 0,
      data: selectedCModule,
      status: '',
      confirmed: false
    };

    $scope.close = function(result) {
      if (result === 'retake') {
        $scope.retake();
      } else {
        $modalInstance.dismiss(result);
      }
    };

    $scope.retake = function() {
      var retake = dashboardResource.retakeMM;

      if(selectedCModule.type === 'course') {
        retake = dashboardResource.retake;
      }

      $scope.modal.status = 'saving';

      retake(selectedCModule.id, selectedCModule.courseId, function(result) {
        $scope.modal.confirmed = true;
        $modalInstance.close();
      }, function(err) {
        $modalInstance.dismiss();
      });
    };
  }
})();
